import React from 'react';

import Grid, { GridProps } from '../Grid';

// TODO: omit all the props related to `container`
type Props = Omit<GridProps, 'container' | 'item'>;

const Row: React.FC<Props> = props => (
  <Grid {...props} item={false} container />
);

export default Row;
